import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-verify-email-container',
  styleUrls: ['./verify-code-component-container.component.scss'],
  templateUrl: './verify-code-component-container.component.html',
})
export class VerifyCodeContainerComponent {}
